<template>
  <div @click.stop="emmitCardClick()" class="product-card">
    <div class="product-card-image">
      <div class="wishlist-icon-container hidden">
        <wishlist-component :product="product" />
      </div>
      <div
        class="image"
        :style="{
          backgroundImage: `url(${getProductImageLowRes(
            product.imageSources[0],
            product.store
          )}), url(${product.imageSources[0]})`
        }"
      ></div>
      <div v-if="product.priceSale" class="sale-banner">
        {{ getSalePercentage }}
      </div>
      <div v-if="product.sustainable" class="sustainable-banner"></div>
    </div>
    <div class="product-card-description">
      <p class="left trunc">{{ product.brand }}</p>
      <p class="right" :class="{ 'price-crossed-out': isOnSale }">
        {{ product.priceOriginal | currency }}
      </p>
      <p class="left trunc">
        {{ `store.${product.store}` | translate | capitalize }}
      </p>
      <p class="right sale-price">
        {{ product.priceSale | currency }}
      </p>
      <p class="name font-weight-normal">{{ product.name }}</p>
    </div>
  </div></template
>

<script>
import { getProductSalePercentage, productImageResizer } from "../../mixins";
import WishlistComponent from "../atoms/wishlist-component";

export default {
  name: "product-card",
  components: { WishlistComponent },
  mixins: [getProductSalePercentage, productImageResizer],
  props: {
    product: {
      required: true,
      type: Object
    }
  },
  methods: {
    emmitCardClick() {
      this.$emit("card-clicked", this.product);
    }
  },
  computed: {
    isOnSale() {
      return !!this.product.priceSale;
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.product-card {
  overflow: hidden;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 150px;
  height: 350px;
  @media (min-width: 1000px) {
    width: 200px;
    height: 500px;
  }
  @media (min-width: 1200px) {
    width: 250px;
    height: 550px;
  }
  @media (min-width: 1500px) {
    width: 300px;
    height: 600px;
  }
  @media (min-width: 1700px) {
    width: 350px;
    height: 650px;
  }
}
.image {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 250px;
  @media (min-width: 1000px) {
    height: 350px;
  }
  @media (min-width: 1200px) {
    height: 400px;
  }
  @media (min-width: 1500px) {
    height: 450px;
  }
  @media (min-width: 1700px) {
    height: 500px;
  }
}
.hidden {
  visibility: hidden;
}
.product-card-image {
  position: relative;
  max-width: 100%;
}
.sale-banner {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 25%;
  height: 10%;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  color: $gyra-red;
  font-size: 2vw;
  @media (min-width: 640px) {
    font-size: 1vw;
  }
}
.sustainable-banner {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 25%;
  height: 10%;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;

  &::after {
    content: "🌱";
    font-size: 2vw;
    @media (min-width: 640px) {
      font-size: 1vw;
    }
  }
}
.product-card-description {
  margin-top: 10px;
  width: auto;
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-template-rows: auto auto auto;
  grid-column-gap: 5px;

  p {
    text-overflow: ellipsis;
    line-height: 0.75rem;
    font-size: 0.6rem;
    font-weight: 500;
    @media (min-width: 700px) {
      line-height: 1rem;
      font-weight: 600;
      font-size: 1vw;
    }
    @media (min-width: 1032px) {
      line-height: 1.5rem;
      font-weight: bold;
    }
  }

  .trunc {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
  }

  .name {
    width: auto;
    white-space: nowrap;
    overflow: hidden;
  }

  .left {
    justify-self: start;
  }

  .right {
    justify-self: end;
  }

  .sale-price {
    font-weight: bold;
    color: $gyra-red;
  }
  .truncate {
    font-weight: normal;
    width: 140%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.price-crossed-out {
  text-decoration: line-through;
}
.wishlist-icon-container {
  position: absolute;
  top: 0;
  right: 10px;
  z-index: 10;
  font-size: 28px;
  @media (min-width: 800px) {
    font-size: 3vw;
  }
  @media (min-width: 1200px) {
    font-size: 40px;
  }
}
.image {
  background-size: cover;
}
</style>
